import api from './api';

export const getDashboard = () =>
  api.get('/admin/dashboard').then(r => r.data);

export const getAdminCompanies = (params = {}) =>
  api.get('/admin/companies', { params }).then(r => r.data);

export const getAdminCompany = (id) =>
  api.get(`/admin/companies/${id}`).then(r => r.data);

export const createAdminCompany = (data) =>
  api.post('/admin/companies', data).then(r => r.data);

export const updateAdminCompany = (id, data) =>
  api.patch(`/admin/companies/${id}`, data).then(r => r.data);

export const deleteAdminCompany = (id) =>
  api.delete(`/admin/companies/${id}`).then(r => r.data);

export const getSubscription = (companyId) =>
  api.get(`/admin/companies/${companyId}/subscription`).then(r => r.data);

export const createSubscription = (companyId, data) =>
  api.post(`/admin/companies/${companyId}/subscription`, data).then(r => r.data);

export const updateSubscription = (companyId, data) =>
  api.patch(`/admin/companies/${companyId}/subscription`, data).then(r => r.data);

export const cancelSubscription = (companyId) =>
  api.post(`/admin/companies/${companyId}/subscription/cancel`).then(r => r.data);

export const getCompanySubscriptions = (companyId) =>
  api.get(`/admin/companies/${companyId}/subscriptions`).then(r => r.data);

export const saveCompanySystemSubscription = (companyId, system, data) =>
  api.post(`/admin/companies/${companyId}/subscriptions/${system}`, data).then(r => r.data);

export const renewCompanySystemSubscription = (companyId, system, data) =>
  api.post(`/admin/companies/${companyId}/subscriptions/${system}/renew`, data).then(r => r.data);

export const toggleCompanySystemSubscription = (companyId, system) =>
  api.post(`/admin/companies/${companyId}/subscriptions/${system}/toggle-status`).then(r => r.data);

export const cancelCompanySystemSubscription = (companyId, system) =>
  api.delete(`/admin/companies/${companyId}/subscriptions/${system}`).then(r => r.data);

export const getPayments = (companyId, params = {}) =>
  api.get(`/admin/companies/${companyId}/payments`, { params }).then(r => r.data);

export const addPayment = (companyId, data) =>
  api.post(`/admin/companies/${companyId}/payments`, data).then(r => r.data);

export const updatePayment = (companyId, paymentId, data) =>
  api.patch(`/admin/companies/${companyId}/payments/${paymentId}`, data).then(r => r.data);

export const chargePayment = (companyId, paymentId, data) =>
  api.post(`/admin/companies/${companyId}/payments/${paymentId}/charge`, data).then(r => r.data);

export const getCompanyUsers = (companyId) =>
  api.get(`/admin/companies/${companyId}/users`).then(r => r.data);

export const addCompanyUser = (companyId, data) =>
  api.post(`/admin/companies/${companyId}/users`, data).then(r => r.data);

export const updateCompanyUser = (companyId, userId, data) =>
  api.patch(`/admin/companies/${companyId}/users/${userId}`, data).then(r => r.data);

export const getAdminPlans = () =>
  api.get('/admin/plans').then(r => r.data);

export const createAdminPlan = (data) =>
  api.post('/admin/plans', data).then(r => r.data);

export const updateAdminPlan = (id, data) =>
  api.patch(`/admin/plans/${id}`, data).then(r => r.data);

export const deleteAdminPlan = (id) =>
  api.delete(`/admin/plans/${id}`).then(r => r.data);

// ── Gestão Isolada por Sistema (Planos, Liberação de Clientes, Parcelas, PIX PagSeguro) ──
export const getSystemSummary = (system) =>
  api.get(`/admin/systems/${system}/summary`).then(r => r.data);

export const getSystemPlans = (system) =>
  api.get(`/admin/systems/${system}/plans`).then(r => r.data);

export const createSystemPlan = (system, data) =>
  api.post(`/admin/systems/${system}/plans`, data).then(r => r.data);

export const updateSystemPlan = (system, id, data) =>
  api.put(`/admin/systems/${system}/plans/${id}`, data).then(r => r.data);

export const deleteSystemPlan = (system, id) =>
  api.delete(`/admin/systems/${system}/plans/${id}`).then(r => r.data);

export const getSystemClients = (system) =>
  api.get(`/admin/systems/${system}/clients`).then(r => r.data);

export const createSystemClient = (system, data) =>
  api.post(`/admin/systems/${system}/clients`, data).then(r => r.data);

export const updateSystemClient = (system, id, data) =>
  api.put(`/admin/systems/${system}/clients/${id}`, data).then(r => r.data);

export const renewSystemClient = (system, id, data) =>
  api.post(`/admin/systems/${system}/clients/${id}/renew`, data).then(r => r.data);

export const toggleSystemClientStatus = (system, id) =>
  api.post(`/admin/systems/${system}/clients/${id}/toggle-status`).then(r => r.data);

export const deleteSystemClient = (system, id) =>
  api.delete(`/admin/systems/${system}/clients/${id}`).then(r => r.data);

export const getSystemPayments = (system, params = {}) =>
  api.get(`/admin/systems/${system}/payments`, { params }).then(r => r.data);

export const createSystemPayment = (system, data) =>
  api.post(`/admin/systems/${system}/payments`, data).then(r => r.data);

export const updateSystemPayment = (system, id, data) =>
  api.put(`/admin/systems/${system}/payments/${id}`, data).then(r => r.data);

export const markSystemPaymentPaid = (system, id) =>
  api.post(`/admin/systems/${system}/payments/${id}/mark-paid`).then(r => r.data);

export const chargeSystemPix = (system, id, data = {}) =>
  api.post(`/admin/systems/${system}/payments/${id}/charge-pix`, data).then(r => r.data);

export const checkSystemPixStatus = (system, id) =>
  api.get(`/admin/systems/${system}/payments/${id}/check-pix`).then(r => r.data);

export const deleteSystemPayment = (system, id) =>
  api.delete(`/admin/systems/${system}/payments/${id}`).then(r => r.data);

export const getPagSeguroSettings = (system = null) => {
  const url = system ? `/admin/systems/${system}/pagseguro-settings` : `/admin/systems-pagseguro/settings`;
  return api.get(url).then(r => r.data);
};

export const updatePagSeguroSettings = (data, system = null) => {
  const url = system ? `/admin/systems/${system}/pagseguro-settings` : `/admin/systems-pagseguro/settings`;
  return api.post(url, data).then(r => r.data);
};

export const testPagSeguroConnection = (data = {}, system = null) => {
  const url = system ? `/admin/systems/${system}/pagseguro-settings/test-connection` : `/admin/systems-pagseguro/test-connection`;
  return api.post(url, data).then(r => r.data);
};

